import React, {Component} from "react";
import ImageLoading from "./ImageLoading";

class Loading extends Component {
	render() {
		return <ImageLoading/>;

		return (
			<div className="loader" {...this.props}>
				<div className="item"></div>
				<div className="item"></div>
				<div className="item"></div>
			</div>
		);
	}
}

export default Loading;


// WEBPACK FOOTER //
// ./src/app/components/Loading.js